import httpUtils from '../../utils/HttpUtils'

class RecommendAppointmentGroupMemberService {

  //获取推荐工长
  async customer(appointmentId = '',memberId = []) {
    let result = null;
    try {
      result = await httpUtils.post('/recommend/appointment/group/member/customer',{appointmentId,memberId})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }
}
export default new RecommendAppointmentGroupMemberService()
